import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import ScrollToTopOnMount from "../components/ScrollToTopOnMount"
import Sidebar from "../components/sidebar.js";
import { Modal, Dropdown, Nav, Tab } from 'react-bootstrap';
import Navbarinner from "../components/Navbarinner.js";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { useTheme } from "../components/ThemeContext";
import revenue from "../assets/images/download (1).png";
import cart from "../assets/images/msg1176172984-45846-removebg-preview.png";
import balance from "../assets/images/Removal-828.png";
import PayoutCircleChart from "../components/payout-circlechart.js";
import PayoutBarChart from "../components/payout-barchart.js";
import { isEmpty } from "../helper/validation.js";
import { createBotCloseReq, getProfitData, getProfitChartData, getStockNews } from "../action/user.action.js";
import { toastAlert } from "../utils/toast.js";

import { getUserProfile } from "../redux/features/user/userslice.js";
import TotalProfit from "../components/shipping-software/total-profit .js";
import { last7DaysArray } from "../lib/dateFn.js";
import Footer from "../components/Footer.js";

import { Doughnut } from 'react-chartjs-2';

const ShippingSoftware = () => {
    const { t } = useTranslation();
    const [isHovered, setIsHovered] = useState(false);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const tradingViewRef = useRef(null);
    const [stockObject, setStockObject] = useState({});
    const [show, setShow] = useState(false);
    const [profitData, setProfitData] = useState({});
    const [totalWeeklyProfit, setTotalWeeklyProfit] = useState(0);
    const [totalProfit, setTotalProfit] = useState(0);
    const [totalbarChartWeeklyProfit, setTotalbarChartWeeklyProfit] = useState([])
    const [stockNews, setStockNews] = useState([])
    const [barChartData, serBarchartData] = useState({
        dataPoints: [0, 0, 0, 0, 0, 0, 0],
        labels: last7DaysArray(),
    })
    const [barChartProfit, serBarChartProfit] = useState([])
    const [barChartLoss, serBarChartLoss] = useState([])
    const [barChartProfitLoss, serBarChartProfitLoss] = useState([])
    const [barChartProfitLossPercent, serBarChartProfitLossPercent] = useState([])
    const [activeItem, setActiveItem] = useState("AMZN");
    const [btcCNVPrice, setBtcCNVPrice] = useState(0);
    const [isCloseBotStatus, setIsCloseBotStatus] = useState(true);
    const { theme } = useTheme();
    const user = useSelector((state) => state.account);
    const priceCNV = useSelector((state) => state.priceconversion)

    const topStoriesList = [
        {
            name: "Amazon.com Inc",
            symbol: "AMZN",
        },
        {
            name: "Alibaba Group Holding Ltd",
            symbol: "BABA",
        },
        {
            name: "Walmart Inc",
            symbol: "WMT",
        },

        {
            name: "eBay Inc",
            symbol: "EBAY",
        },
        {
            name: "JD.com Inc",
            symbol: "JD",
        },
        {
            name: "Etsy Inc",
            symbol: "ETSY",
        },
        {
            name: "BigCommerce Holdings Inc",
            symbol: "BIGC",
        },

        {
            name: "Sea Ltd",
            symbol: "SE",
        },
        {
            name: "MercadoLibre Inc",
            symbol: "MELI",
        },


    ]

    useEffect(() => {
        if (user && user?.botStatus === "deActive") {
            navigate("/dashboard");
        }
        if (user && user.botCloseStatus === "OFF") {
            setIsCloseBotStatus(false);
        }
    }, [user]);
    useEffect(() => {
        if (tradingViewRef.current) {
            tradingViewRef.current.innerHTML = "";
        }

        const script = document.createElement("script");
        script.type = "text/javascript";
        script.async = true;
        script.src = "https://s3.tradingview.com/external-embedding/embed-widget-timeline.js";
        script.innerHTML = `
        {
         "feedMode": "symbol",
         "symbol": "${isEmpty(stockObject.symbol) ? "AMZN" : stockObject.symbol}",        
        "isTransparent": false,
          "displayMode": "regular",
          "width": "100%",
          "height": "100%",
          "colorTheme": "${theme}",
          "locale": "en"
        }`;
        if (tradingViewRef.current) {
            tradingViewRef.current.appendChild(script);
        }
    }, [theme, stockObject]);

    useEffect(() => {

        let btcPrice = priceCNV.find((item) => item?.baseSymbol === "BTC" && item?.convertSymbol === "USD")?.convertPrice || 0
        setBtcCNVPrice(btcPrice)
    }, [priceCNV])
    const fetchProfitData = async () => {
        try {
            const { status, result, message } = await getProfitData();
            if (status) {
                setProfitData(result);
            }
        } catch (err) {
            console.log(err);
        }
    };


    const fetchStockNews = async (activeItem) => {
        try {
            const { status, result, message } = await getStockNews(activeItem);
            if (status) {
                setStockNews(result);
            }
        } catch (err) {
            console.log(err);
        }
    }
    useEffect(() => {
        fetchProfitData();
        fetchStockNews(activeItem);
    }, []);

    const fetchProfitChartData = async () => {
        try {
            const { status, result, message } = await getProfitChartData();
            if (status) {
                setTotalWeeklyProfit(result?.totalWeeklyProfit || 0);
                setTotalProfit(result?.totalProfit || 0);
                setTotalbarChartWeeklyProfit(result?.totalbarChartWeeklyProfit || [])
                if (result?.totalbarChartWeeklyProfit && result?.totalbarChartWeeklyProfit.length > 0) {
                    let dataPoints = result?.totalbarChartWeeklyProfit.map((item) => item?.total)
                    let labels = result?.totalbarChartWeeklyProfit.map((item) => moment(item._id).format("MMM DD"),)
                    serBarchartData({
                        dataPoints: dataPoints,
                        labels: labels,
                    })
                }
            }
        } catch (err) {
            console.log(err);
        }
    }
    useEffect(() => {
        fetchProfitChartData()
    }, [])

    const handleStockClick = (item) => {
        setStockObject(item)
        fetchStockNews(item.symbol);
        setActiveItem(item.symbol);
    }

    const handleCloseBot = async () => {
        try {

            let data = {
                closeStatus: isCloseBotStatus ? "ON" : "OFF"
            }
            const { status, result, message } = await createBotCloseReq(data);
            if (status) {
                toastAlert("success", t(message));
                if (!isCloseBotStatus) {
                    setIsCloseBotStatus(!isCloseBotStatus);
                }
                setShow(false);
                dispatch(getUserProfile());
            } else {
                toastAlert("error", t(message));
            }
            return;
        } catch (err) {
            console.log(err);
        }

    }
    const handleToggleChange = async (e) => {
        e.preventDefault();
        if (!e.target.checked) {
            setIsCloseBotStatus(e.target.checked);
            setShow(true);

        } else {
            setIsCloseBotStatus(e.target.checked);
            setShow(true);
        }
    }




    const chartData = {
        labels: ['Faschion', 'Tech', 'Home'],
        datasets: [
            {
                data: [55, 25, 20],
                backgroundColor: ['#E91E63', '#009688', '#FF9800'],
                borderWidth: 0,
            },
        ],
    };

    const options = {
        cutout: '70%',
        plugins: {
            legend: {
                display: false,
            },
        },
    };

    const sectors = [
        { name: 'Fashion', percent: 55, color: '#E91E63' },
        { name: 'Tech', percent: 25, color: '#009688' },
        { name: 'Home', percent: 20, color: '#FF9800' },
    ];

    return (
        <>
            <div className="page_wrapper " >
                <ScrollToTopOnMount />
                <Sidebar navLink={"/shipping-software"} />
                <div className="w-100" >
                    <Navbarinner />
                    <div className="right_wrapper" >
                        <div className="shipping_software dashboard">
                            <div className="h_flx">
                                <h3 className="h3tag mb-0">{t("SHIPPING_SOFTWARE_TITLE")}</h3>
                                <div className="d-flex gap-3">
                                    <Link
                                        to="/software-account-types"
                                        style={{ textDecoration: "none" }}
                                        className="primary_btn market_btn"
                                    >
                                        {t("SOFTWARE_ACCOUNT_TYPES")}
                                    </Link>
                                    {
                                        (user?.botCloseStatus === "ON" || user?.botCloseStatus === "OFF") &&
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                            <span style={{ marginRight: "8px", fontWeight: "bold" }}>{t("OFF")}</span>
                                            <label className="switch">
                                                <input type="checkbox" disabled={user?.botCloseStatus === "SENT"} checked={isCloseBotStatus} onChange={handleToggleChange} />
                                                <span className="slider round"></span>
                                            </label>
                                            <span style={{ marginLeft: "8px", fontWeight: "bold" }}>{t("ON")}</span>
                                        </div>
                                    }

                                    {
                                        user?.botCloseStatus === "SENT" &&
                                        <div style={{ display: "flex", alignItems: "center", position: "relative" }}>
                                            <span style={{ marginRight: "8px", fontWeight: "bold" }}>{t("OFF")}</span>

                                            <label
                                                className="switch"
                                                onMouseEnter={() => setIsHovered(true)}
                                                onMouseLeave={() => setIsHovered(false)}
                                                style={{ position: "relative" }}
                                            >
                                                <input
                                                    type="checkbox"
                                                    disabled={user?.botCloseStatus === "SENT"}
                                                    checked={isCloseBotStatus}
                                                    onChange={handleToggleChange}
                                                />
                                                <span className="slider round"></span>

                                                {isHovered && (
                                                    <span
                                                        style={{
                                                            position: "absolute",
                                                            top: "-35px",
                                                            left: "10%",
                                                            transform: "translateX(-50%)",
                                                            backgroundColor: "#333",
                                                            color: "#fff",
                                                            padding: "4px 8px",
                                                            borderRadius: "4px",
                                                            fontSize: "12px",
                                                            whiteSpace: "nowrap",
                                                            zIndex: 10,
                                                        }}
                                                    >
                                                        {t("BOT_CLOSE_REQUEST_SENT")}
                                                    </span>
                                                )}
                                            </label>

                                            <span style={{ marginLeft: "8px", fontWeight: "bold" }}>{t("ON")}</span>
                                        </div>
                                    }

                                </div>
                            </div>
                            <TotalProfit profitData={profitData} btcCNVPrice={parseFloat(btcCNVPrice)} totalProfit={totalProfit} />

                            <div className="chart_flx custom_flx">
                                <div className="box flex-column align-items-stretch">
                                    <div className="w-100">
                                        <h5>{t("TRADING_VIEW_ECOMMERCE_STOCKS")}</h5>
                                        <ul className="stocks_list">
                                            {
                                                topStoriesList.map((item, index) => {
                                                    return (
                                                        <li key={index} onClick={() => handleStockClick(item)}
                                                            className={activeItem === item.symbol ? 'active' : ''}
                                                        >
                                                            {item.name}
                                                        </li>
                                                    )
                                                }
                                                )
                                            }
                                            {/* <li>AliExpress</li>
                                            <li>CJ Dropshipping</li>
                                            <li>Spocket</li>
                                            <li>Zendrop</li>
                                            <li>AutoDS</li>
                                            <li>Modalyst</li>
                                            <li>Printful</li>
                                            <li>SaleHoo</li>
                                            <li>Banggood</li>
                                            <li>TeeLaunch</li> */}
                                        </ul>
                                    </div>

                                </div>
                                <div className="box flex-column align-items-stretch">
                                    <h5>{t('WEEKLY_PROFIT')}</h5>
                                    <div className="chart_box d-flex flex-column align-items-center text-center gap-4">
                                        <PayoutCircleChart theme={theme} value={totalWeeklyProfit} total={totalProfit} btcCNVPrice={btcCNVPrice}
                                        />
                                        {/* <p>{t("SHIPPING_SOFTWARE_PAGE_WEEKLY_PROFIT_CONTENT")}</p> */}
                                        <div className="custom_flx_canvas">
                                        <PayoutBarChart
                                            theme={theme}
                                            dataPoints={barChartData?.dataPoints}
                                            labels={barChartData?.labels}
                                           
                                        />
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="box flex-column align-items-stretch p-3">
                                    <div ref={tradingViewRef} className="tradingview-widget-container" >
                                        <div className="tradingview-widget-container__widget"></div>
                                        <div className="tradingview-widget-copyright">
                                            <a href="https://www.tradingview.com/" rel="noopener nofollow" target="_blank">
                                                <span className="blue-text">Track all markets on TradingView</span>
                                            </a>
                                        </div>
                                    </div>
                                 

                                </div> */}

                               
                                <div className="box flex-column align-items-stretch p-3" >
                                    <div className="news-widget-list">
                                        {stockNews.map((item, index) => (
                                            <div className="news-widget-item" key={index}>
                                                <a href={item.url} target="_blank" rel="noopener noreferrer">
                                                    <div className="news-content">
                                                        <img
                                                            src={item.imageUrl}
                                                            alt={item.source}
                                                            width="60"
                                                            height="60"
                                                            className="news-image"
                                                            onError={(e) =>
                                                                (e.target.src = 'https://via.placeholder.com/60x60.png?text=News')
                                                            }
                                                        />
                                                        <div className="news-text">
                                                            <h1 className="news-title">{item.headline}</h1>
                                                            <span className="news-meta">
                                                                {item.source} •{' '}
                                                                {moment(item?.publishedAt).format('MMM D, YYYY h:mm A')}
                                                            </span>
                                                        </div>

                                                    </div>
                                                </a>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            <div className="custom_fund d-flex gap-3">
                                 <div className="box flex-column align-items-stretch custom_fund1">
                                    <h5>Your Portfolio</h5>

                                    <div className="chart_box d-sm-flex  align-items-center text-center gap-3">
                                        <div className="d-sm-block d-flex justify-content-center">
                                            <Doughnut data={chartData} options={options} style={{ width: "170px", height: "170px" }} />
                                        </div>

                                        <div className="portfolio-list text-start">
                                            {sectors.map((item, index) => (
                                                <div
                                                    key={index}
                                                    className="d-flex justify-content-between align-items-center gap-4 mb-1 mt-2"
                                                >
                                                    <div className="d-flex align-items-center gap-2">
                                                        <span
                                                            style={{
                                                                display: 'inline-block',
                                                                width: '15px',
                                                                height: '15px',
                                                                borderRadius: '50%',
                                                                backgroundColor: item.color,
                                                            }}
                                                        ></span>
                                                        <span>{item.name}</span>
                                                    </div>
                                                    <span>{item.percent} %</span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>


                                <div className="box custom_fund2">
                                    <div className="d-sm-flex justify-content-between p-3 align-items-center w-100">
                                        <div>
                                            <h1 className="mb-2">Boost your monthly profit by reinvesting your earnings</h1>
                                            <h2 className="mb-3">
                                                Reinvest Amount: &nbsp; <span className="font-semibold">$1000</span>
                                            </h2>
                                        </div>
                                        <div>
                                            <button className="primary_btn p-3">Add Funds</button>
                                        </div>

                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                     <div className="mt-5">
                <Footer />
            </div>
                </div>
            </div>

           
            <Modal show={show} centered size="sm" className="custom_modal" >
                <Modal.Header className="mb-3"  >
                    <div className="cursor-pointer" >
                        <h6>{!isCloseBotStatus ? t("ARE_YOU_SURE_WANT_TO_CLOSE_BOT") : t("ARE_YOU_SURE_WANT_TO_OPEN_BOT")}?</h6>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <button class="secondary_btn" style={{ backgound: "none !important" }} onClick={() => {
                        setIsCloseBotStatus(user?.botCloseStatus === "OFF" ? false : true);
                        setShow(false)
                    }} > {t("CANCEL")}
                    </button>
                    &nbsp; &nbsp;
                    <button class="primary_btn" onClick={handleCloseBot} > {t("CONFIRM")}
                    </button>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ShippingSoftware;